import SectionTitle from "./SectionTitle";

const sports = [
  {
    icon: "ri-football-line",
    title: "Football (Soccer)",
    items: [
      { name: "A-League & International", desc: "Bet on Australian A-League matches and international football including Premier League, Champions League, and World Cup qualifiers." },
      { name: "Asian Football Markets", desc: "Wide coverage of Asian football leagues with competitive odds and multiple betting markets including Asian handicap." },
    ],
  },
  {
    icon: "ri-trophy-line",
    title: "Horse Racing",
    items: [
      { name: "Australian Racing", desc: "Bet on major Australian horse racing events including the Melbourne Cup, Cox Plate, and daily race meetings across all states." },
      { name: "International Races", desc: "Wager on international horse racing from the UK, Hong Kong, Japan, and the USA with win, place, and exotic bets." },
    ],
  },
  {
    icon: "ri-basketball-line",
    title: "Basketball (NBL & NBA)",
    items: [
      { name: "NBL Australia", desc: "Bet on the National Basketball League Australia with match winner, point spreads, and player performance markets." },
      { name: "NBA", desc: "Full coverage of NBA games with live betting, point spreads, total points, and player prop markets." },
    ],
  },
  {
    icon: "ri-run-line",
    title: "Rugby & AFL",
    items: [
      { name: "AFL (Australian Football)", desc: "Australia's most popular sport. Bet on AFL matches with head-to-head, line betting, and total disposals markets." },
      { name: "NRL Rugby League", desc: "Comprehensive NRL coverage with match winner, first try scorer, and handicap betting options." },
    ],
  },
  {
    icon: "ri-gamepad-line",
    title: "eSports Betting",
    items: [
      { name: "League of Legends & Dota 2", desc: "Predict outcomes of top-tier eSports tournaments. Every kill, tower, and objective counts toward your winnings." },
      { name: "CS2 & Valorant", desc: "Sharp shooting and strategic gameplay set the stage for thrilling eSports bets with competitive odds." },
    ],
  },
];

export default function SportsBetting() {
  return (
    <section id="sports" className="py-12">
      <SectionTitle>Sports Betting</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        Step into the electrifying world of Ace96au sports betting, where every match becomes an opportunity. From Australian AFL and NRL to international football, horse racing, basketball, and eSports — Ace96au covers all the markets Australian punters love with competitive odds and live betting options. New sports bettors enjoy a 50% Sport Welcome Bonus on their first sports deposit.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {sports.map((sport, i) => (
          <div
            key={i}
            className="glass-card rounded-2xl p-5 transition-all duration-300 group cursor-default"
          >
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300 group-hover:scale-110"
                style={{
                  background: "linear-gradient(135deg, rgba(16,92,232,0.25), rgba(16,92,232,0.12))",
                  border: "1px solid rgba(16,92,232,0.25)",
                }}
              >
                <i className={`${sport.icon} text-lg`} style={{ color: "#105CE8" }}></i>
              </div>
              <h3 className="text-white font-bold text-sm">{sport.title}</h3>
            </div>
            <div className="space-y-2">
              {sport.items.map((item, j) => (
                <div key={j}>
                  <strong className="text-xs" style={{ color: '#105CE8' }}>{item.name}: </strong>
                  <span className="text-slate-400 text-xs">{item.desc}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
